import { getMessages } from '../../../../../../../../store/constants';

export const STATUS_LIST_TOGGLE_WORK_ON_HOLD = getMessages().getText('board_settings.statuslist.toggle.workOnHold');
export const STATUS_LIST_MODAL_CANCEL = getMessages().getText('common.cancel');
export const STATUS_LIST_MODAL_REMOVE = getMessages().getText('common.turn_off');
export const STATUS_LIST_MODAL_TEXT = getMessages().getText('board_settings.statuslist.modal.text');
export const STATUS_LIST_MODAL_TITLE = getMessages().getText('board_settings.statuslist.modal.title');
